module.exports = __webpack_public_path__ + "static/media/gallerryimg2.c4cfc012.jpg";